module.exports = __webpack_public_path__ + "static/media/B_FD-cover.f03f7078.png";